import { render } from "./MenuComponent.vue?vue&type=template&id=790e5aa6"
import script from "./MenuComponent.vue?vue&type=script&lang=js"
export * from "./MenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__